import React from 'react';
import "../../css/dashboardStylings/DashboardWeatherHelperStyling.css";

const DashboardWeatherHelperComponent = () => {
    return (
        <div className={`dashboard-weather-helper-body`}>
            <div className="construction-message">
                <div>🚧 This component is under construction! 🚧</div>
                <div className="construction-subtitle">We're working hard to bring you something amazing.</div>
            </div>
        </div>
    )
}

export default DashboardWeatherHelperComponent;